angular
  .module('contrast.services.trends', [])
  .factory('TrendService', function (RULE_SEVERITY_ENUM) {
    function getTrendInfo(values, timeAttr, valueAttr) {
      if (values.length > 0) {
        values.sort(function (a, b) {
          return a[timeAttr] - b[timeAttr]
        })

        var initialValue = values[values.length - 1][valueAttr],
          currentValue = values[0][valueAttr],
          diff = currentValue - initialValue,
          change =
            currentValue == 0
              ? diff != 0
                ? 100
                : 0
              : (diff / currentValue) * 100

        return {
          change: Math.abs(change),
          increase: diff < 0
        }
      }

      return {
        change: 0,
        increase: 0
      }
    }

    return {
      getScoreTrendInfo: function (scores) {
        return getTrendInfo(scores, 'timestamp', 'score')
      },

      getAttackTrendInfo: function (scores) {
        return getTrendInfo(scores, 'creation', 'total_attacks')
      },

      getTraceTTRSeverityData: function (data) {
        var trendData = data.trend,
          currentData = trendData[0]

        for (var i = 1; i < trendData.length; i++) {
          if (trendData[i].timestamp > currentData.timestamp) {
            currentData = trendData[i]
          }
        }

        var critical = currentData.stats.find(function (rec) {
            return rec.label == RULE_SEVERITY_ENUM.CRITICAL
          }),
          high = currentData.stats.find(function (rec) {
            return rec.label == RULE_SEVERITY_ENUM.HIGH
          }),
          medium = currentData.stats.find(function (rec) {
            return rec.label == RULE_SEVERITY_ENUM.MEDIUM
          })

        return {
          critical: angular.isObject(critical) ? critical.average : 0,
          high: angular.isObject(high) ? high.average : 0,
          medium: angular.isObject(medium) ? medium.average : 0
        }
      }
    }
  })
